import React, { FC, ReactNode } from 'react'

type BasicCardProps = {
  children: ReactNode
}

export const BasicCard: FC<BasicCardProps> = ({ children }) => (
  <div className="basiccard row px-1 pb-3 mx-2 mt-2">{children}</div>
)
